import api from '../utils/api';

export async function listScheduledMessagesAdmin({
  page = 1,
  perPage = 20,
  status = null,
  agentId = null,
  search = null,
  recurrencePreset = null,
  recurrenceDays = null,
} = {}) {
  const params = { page, per_page: perPage };
  if (status) {
    params.status = status;
  }
  if (agentId) {
    params.agent_id = agentId;
  }
  if (search) {
    params.search = search;
  }
  if (recurrenceDays) {
    params.recurrence_days = recurrenceDays;
  } else if (recurrencePreset) {
    params.recurrence_preset = recurrencePreset;
  }
  const { data } = await api.get('/admin/scheduled-messages', { params });
  return data;
}

export async function listRecurrenceDayPatternsAdmin({ agentId = null } = {}) {
  const params = {};
  if (agentId) {
    params.agent_id = agentId;
  }
  const { data } = await api.get('/admin/scheduled-messages/recurrence-patterns', { params });
  return data;
}

export async function getScheduledMessageAdmin(id) {
  const { data } = await api.get(`/admin/scheduled-messages/${id}`);
  return data;
}

export async function createScheduledMessageAdmin(agentId, payload) {
  const { data } = await api.post(`/admin/agents/${agentId}/scheduled-messages`, payload);
  return data;
}

export async function cancelScheduledMessageAdmin(id) {
  const { data } = await api.post(`/admin/scheduled-messages/${id}/cancel`);
  return data;
}

export async function deleteScheduledMessageAdmin(id) {
  const { data } = await api.delete(`/admin/scheduled-messages/${id}`);
  return data;
}

export async function retryScheduledMessageAdmin(id) {
  const { data } = await api.post(`/admin/scheduled-messages/${id}/retry`);
  return data;
}

export async function resendScheduledMessageAdmin(id) {
  const { data } = await api.post(`/admin/scheduled-messages/${id}/resend`);
  return data;
}

export async function forceDispatchScheduledMessageAdmin(id) {
  const { data } = await api.post(`/admin/scheduled-messages/${id}/dispatch-now`);
  return data;
}

export async function sendScheduledMessageTemplateAdmin(id) {
  const { data } = await api.post(`/admin/scheduled-messages/${id}/send-template`);
  return data;
}

export async function updateScheduledMessageAdmin(id, payload) {
  const { data } = await api.patch(`/admin/scheduled-messages/${id}`, payload);
  return data;
}
